import React from "react";
import { saveAs } from "file-saver";
import HtmlDocx from "html-docx-js/dist/html-docx";
import Payments from "./payments";
import { FaFileWord } from "react-icons/fa";
import ReportPage from "./ipsas/parts";
import AccountingPolicies from "./ipsas/bottom";

const Ipsas = ({startDate, endDate}) => {
  const exportToWord = async () => {
    try {
      // Get HTML content from the DOM
      const content = document.querySelector(".toBeExported").innerHTML;
      // Convert HTML content to a .docx file using html-docx-js
      const converted = HtmlDocx.asBlob(content);
      saveAs(converted, "exported-content.docx");
    } catch (error) {
      console.error("Error exporting to Word:", error);
    }
  };

  return (
    <div>
        <button
        className="px-4 py-2 m-4 bg-blue-950 text-white rounded-md"
         onClick={exportToWord}> <FaFileWord/> </button>
      <div className="toBeExported">
        <ReportPage/>
        <Payments startDate={startDate} endDate={endDate}/>
        <p>
        Incorporated in the payments recognised in this Statement are those for Local Government Equalisation and Constituency Development Funds. However, the details of payments under each of these Funds are presented separately in each Fund’s own Statement of Cash Receipts and Payments.
        </p>
        <p>
        In the comparative financial statement for 2022 has been restated due to the overstatement on note 12 of  Other receipts. The correction has been done as follows; Note 3 on Fees and charges was understateted K94,331 while note 9 on other grants was understated K180,635 which was misclasfied now corrected. Use of goods and services on note 14 was understatement now corrected after reconciliation.
The closing bank balance has been corrected after reconcilliations.
        </p>
        <Payments startDate={startDate} endDate={endDate}/>
        <AccountingPolicies/>
      </div>
      
    </div>
  );
};

export default Ipsas;
